(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsSocialPostsDomainModeFilters(
            module.exports
        );

    } else {
        RivalIQ.module('enums');

        enumsSocialPostsDomainModeFilters(
            RivalIQ.enums
        );
    }

    function enumsSocialPostsDomainModeFilters(exports) {

        exports.socialPostsDomainModeFilters = {
            all: {
                id: 'all',
                name: 'All Content'
            },
            owned: {
                id: 'owned',
                name: 'Owned'
            },
            curated: {
                id: 'curated',
                name: 'Curated'
            }
        };
    }
})();
